import { CheckIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";
import type { PracticeLabStepStateResponse } from "@/types/practice-lab";

// Left rail. Dot state (done / active / locked) comes from the server's
// rail_status. Sticky on desktop, stacks above the panel on mobile.
export function StepRail({ steps }: { steps: PracticeLabStepStateResponse[] }) {
  return (
    <Card className="py-3 lg:sticky lg:top-20">
      <CardContent className="px-3">
        <ol className="space-y-0.5">
          {steps.map((s) => {
            const done = s.rail_status === "done";
            const active = s.rail_status === "active";
            const locked = s.rail_status === "locked";
            return (
              <li
                key={s.step_id}
                className={cn(
                  "flex items-start gap-3 rounded-lg px-3 py-2.5",
                  active && "bg-muted"
                )}
              >
                <span
                  className={cn(
                    "mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
                    done && "bg-green-600 text-white",
                    active && "border-2 border-primary text-primary",
                    locked && "bg-muted text-muted-foreground/50"
                  )}
                >
                  {done ? <CheckIcon className="size-3.5" /> : s.order}
                </span>
                <span className="min-w-0">
                  <span className="block text-xs font-medium uppercase tracking-wide text-muted-foreground">
                    Step {s.order}
                    {active ? " · now" : ""}
                  </span>
                  <span
                    className={cn(
                      "block text-sm font-medium leading-snug",
                      locked && "text-muted-foreground"
                    )}
                  >
                    {s.title}
                  </span>
                </span>
              </li>
            );
          })}
        </ol>
      </CardContent>
    </Card>
  );
}
